import { render, staticRenderFns } from "./fixSortAdd.vue?vue&type=template&id=639f303a&scoped=true&"
import script from "./fixSortAdd.vue?vue&type=script&lang=js&"
export * from "./fixSortAdd.vue?vue&type=script&lang=js&"
import style0 from "./fixSortAdd.vue?vue&type=style&index=0&id=639f303a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f303a",
  null
  
)

export default component.exports